import { render, staticRenderFns } from "./PeriodNavigator.vue?vue&type=template&id=6490b8a1&scoped=true&"
import script from "./PeriodNavigator.vue?vue&type=script&lang=js&"
export * from "./PeriodNavigator.vue?vue&type=script&lang=js&"
import style0 from "./PeriodNavigator.vue?vue&type=style&index=0&id=6490b8a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490b8a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
